import React from 'react';

function StepConditionalLogic({ 
  step, 
  stepIndex, 
  plan, 
  selectedTestCaseIndex, 
  stepFilters, 
  onUpdateStep,
  onUpdateStepFilters
}) {
  return (
    <div className="form-group">
      <label>Conditional Logic (optional)</label>
      {plan.test_cases[selectedTestCaseIndex]?.steps.slice(0, stepIndex).length > 0 && (
        <div className="step-filter">
          <input
            type="text"
            placeholder="Filter previous steps..."
            value={stepFilters[stepIndex] || ''}
            onChange={(e) => onUpdateStepFilters(stepIndex, e.target.value)}
          />
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
        <select
          className="form-control"
          value={step.condition?.step_id || ''}
          onChange={(e) => {
            if (e.target.value) {
              const selectedStep = plan.test_cases[selectedTestCaseIndex]?.steps.find(s => s.id === e.target.value);
              if (selectedStep?.step_type === 'question') {
                const firstOption = selectedStep.question?.options.find(opt => opt.trim() !== '') || '';
                onUpdateStep(stepIndex, 'condition', { 
                  step_id: e.target.value, 
                  answer_equals: step.condition?.answer_equals || firstOption
                });
              } else {
                onUpdateStep(stepIndex, 'condition', { 
                  step_id: e.target.value, 
                  equals: step.condition?.equals || 'Pass' 
                });
              }
            } else {
              onUpdateStep(stepIndex, 'condition', null);
            }
          }}
        >
          <option value="">No condition</option>
          {plan.test_cases[selectedTestCaseIndex]?.steps.slice(0, stepIndex)
            .filter(prevStep => {
              const filter = stepFilters[stepIndex]?.toLowerCase() || '';
              return !filter || 
                     prevStep.title.toLowerCase().includes(filter) ||
                     prevStep.id.toLowerCase().includes(filter);
            })
            .map((prevStep, prevIndex) => (
              <option key={prevIndex} value={prevStep.id}>
                Show if "{prevStep.title || prevStep.id}" {prevStep.step_type === 'question' ? 'answer' : 'result'} is...
              </option>
            ))}
        </select>
        {step.condition && (
          <select
            className="form-control"
            value={step.condition.equals || step.condition.answer_equals || ''}
            onChange={(e) => {
              const selectedStep = plan.test_cases[selectedTestCaseIndex]?.steps.find(s => s.id === step.condition.step_id);
              if (selectedStep?.step_type === 'question') {
                onUpdateStep(stepIndex, 'condition', { 
                  ...step.condition, 
                  answer_equals: e.target.value,
                  equals: undefined
                });
              } else {
                onUpdateStep(stepIndex, 'condition', { 
                  ...step.condition, 
                  equals: e.target.value,
                  answer_equals: undefined
                });
              }
            }}
          >
            {(() => {
              const selectedStep = plan.test_cases[selectedTestCaseIndex]?.steps.find(s => s.id === step.condition.step_id);
              if (selectedStep?.step_type === 'question') {
                return selectedStep.question?.options.map((option, optIndex) => (
                  <option key={optIndex} value={option}>{option}</option>
                ));
              } else {
                return (
                  <>
                    <option value="Pass">Pass</option>
                    <option value="Fail">Fail</option>
                    <option value="Skip">Skip</option>
                  </>
                );
              }
            })()}
          </select>
        )}
      </div>
      {step.condition && (
        <small style={{ color: '#6b7280', marginTop: '0.25rem', display: 'block' }}>
          {(() => {
            const selectedStep = plan.test_cases[selectedTestCaseIndex]?.steps.find(s => s.id === step.condition.step_id);
            if (selectedStep?.step_type === 'question') {
              return `This step will only show if the answer to "${selectedStep.title || selectedStep.id}" is "${step.condition.answer_equals}"`;
            } else {
              return `This step will only show if the result of "${selectedStep?.title || selectedStep?.id}" is "${step.condition.equals}"`;
            }
          })()}
        </small>
      )}
    </div>
  );
}

export default StepConditionalLogic; 